import React from "react"

//-------Corporative
import BrandsHotels from "./views/corporative/BrandsHotels";
import RegionsCities from "./views/corporative/RegionsCities";
import CorporativeCatalogs from "./views/corporative/CorporativeCatalogs";
import CorporativeParsing from "./views/corporative/CorporativeParsing";
import Roles from "./views/corporative/Roles";
import Users from "./views/corporative/Users";

//-------Property
import Catalogs from "./views/property/Catalogs";
import CutOffDate from "./views/property/CutOffDate";
import Expressions from "./views/property/Expressions";
import ImportData from "./views/property/ImportData";
import ParsingDB from "./views/property/ParsingDB";
import Seasons from "./views/property/Seasons";


class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <div className="layout">
                <div className={"brands-hotels "  + (this.props.app.state.section_active !== "brands-hotels" ? "hide" : "")}>
                    <BrandsHotels />
                </div>
                <div className={"regions-cities "  + (this.props.app.state.section_active !== "regions-cities" ? "hide" : "")}>
                    <RegionsCities />
                </div>
                <div className={"corporative-catalogs "  + (this.props.app.state.section_active !== "corporative-catalogs" ? "hide" : "")}>
                    <CorporativeCatalogs
                        catalogs={this.props.catalogs}
                     />
                </div>
                <div className={"corporative-parsing "  + (this.props.app.state.section_active !== "corporative-parsing" ? "hide" : "")}>
                    <CorporativeParsing
                        catalogs={this.props.catalogs}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                    />
                </div>
                <div className={"roles "  + (this.props.app.state.section_active !== "roles" ? "hide" : "")}>
                    <Roles />
                </div>
                <div className={"users "  + (this.props.app.state.section_active !== "users" ? "hide" : "")}>
                    <Users />
                </div>

                
                <div className={"catalogs "  + (this.props.app.state.section_active !== "catalogs" ? "hide" : "")}>
                    <Catalogs 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                    />
                </div>
                <div className={"cut-off-date "  + (this.props.app.state.section_active !== "cut-off-date" ? "hide" : "")}>
                    <CutOffDate 
                        app={this.props.app}
                    />
                </div>
                <div className={"expressions "  + (this.props.app.state.section_active !== "expressions" ? "hide" : "")}>
                    <Expressions 
                        app={this.props.app}
                    />
                </div>
                <div className={"import-data "  + (this.props.app.state.section_active !== "import-data" ? "hide" : "")}>
                    <ImportData 
                        app={this.props.app}
                        renderSelectHotels={this.props.renderSelectHotels}
                        setActiveHotel = {this.props.setActiveHotel}
                    />
                </div>
                <div className={"parsing-db "  + (this.props.app.state.section_active !== "parsing-db" ? "hide" : "")}>
                    <ParsingDB 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                        renderSelectHotels={this.props.renderSelectHotels}
                    />
                </div>
                <div className={"seasons "  + (this.props.app.state.section_active !== "seasons" ? "hide" : "")}>
                    <Seasons 
                        app={this.props.app}
                    />
                </div>
                
            </div>
        )
    }

}

export default Layout


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/Layout.js